export const addEditOfferFormLayout = (isAdd: boolean) => {
  return {
    labelCol: {
      sm: { span: 24 },
      md: { span: 8 },
      lg: { span: !isAdd ? 11 : 8 },
      xl: { span: !isAdd ? 9 : 7 },
      xxl: { span: 7 },
    },
    wrapperCol: {
      lg: { span: !isAdd ? 24 : 14 },
      xl: { span: !isAdd ? 24 : 12 },
    },
  };
};
